module.exports = __webpack_public_path__ + "img/maths.8188abed.png";